import { useState, useEffect } from 'react'

const detectWebpSupport = async () => {
  if (window.SUPPORTS_WEBP !== undefined) return window.SUPPORTS_WEBP

  const promise = new Promise((resolve) => {
    const image = new Image()
    const imageEventListener = event => resolve(event && event.type === 'load' ? image.width === 1 : false)
    image.onerror = imageEventListener
    image.onload = imageEventListener
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA='
  })
  window.SUPPORTS_WEBP = await promise
  return window.SUPPORTS_WEBP
}

export const useSupportsWebp = () => {
  const [supportsWebp, setSupportsWebp] = useState(null)

  useEffect(() => {
    const detect = async () => {
      const value = await detectWebpSupport()
      setSupportsWebp(value)
    }
    detect()
  }, [])

  return supportsWebp
}
